import React from 'react';
import UserAgreement from './user-agreement.tsx';


//-----------------------------------------------------------------------------------------
// Public Components:
//-----------------------------------------------------------------------------------------

export default function TermsAndConditionsView() {
	return (
		<UserAgreement
			id="terms-and-conditions"
			title="Terms and Conditions for the Morgan Car Configurator"
			sections={[
				{
					title: 'Information Purposes Only',
					description:
						<div>
							<p>
								The content of the Morgan car configurator is provided for informational
								purposes only and is not intended to be interpreted as an offer for the sale of
								any specific goods.
							</p>
						</div>

				},
				{
					title: 'Accuracy and Guidance',
					description:
						<div>
							<p>
								The Morgan Motor Company strives to provide accurate and up-to-date
								information within the Morgan car configurator. However, it should be used for
								guidance only. Exact specifications, prices, colors, and the availability of options
								may differ from those shown.
							</p>
						</div>

				},
				{
					title: 'Right to Make Changes',
					description:
						<div>
							<p>
								Morgan Motor Company reserves the right to make changes to prices, product
								specifications, and the availability of options at any time without notice. Please
								always consult your Morgan Dealer for the most up-to-date information. If
								applicable, first-year vehicle excise duty and first registration fees will be
								confirmed by the supplying dealer.
							</p>
						</div>
				},
				{
					title: 'Optional Equipment',
					description:
						<div>
							<p>
								Some optional equipment may not be available or homologated for all markets
								and may be subject to additional fitting fees. Please contact your Morgan Dealer
								for availability and prices.
							</p>
						</div>
				},
				{
					title: 'Color and Finish Representation',
					description:
						<div>
							<p>
								All colors, textures, and finishes represented in the Morgan car configurator
								may vary in appearance depending on the device screen or printer used to view
								them. Therefore, exact finishes should be used for guidance only and verified
								with your Morgan Dealer. Suitable paint codes are required to produce special
								paint colors.
							</p>
						</div>
				},
				{
					title: 'Additional Costs',
					description:
						<div>
							<p>
								Actual costs, including delivery, registration, pre-delivery inspection, and
								market-specific taxation, may be additional to the price shown on the Morgan
								car configurator and will be set by the supplying Morgan Dealer.
							</p>
						</div>
				},
				{
					title: 'Promotions',
					description:
						<div>
							<p>
								Any promotions displayed are subject to availability for a limited time at
								participating Morgan Dealers only. Please contact your Morgan Dealer to
								confirm vehicle availability, current prices, and promotions.
							</p>
						</div>
				},
				{
					title: 'Beta Application Disclaimer',
					description:
						<div>
							<p>
								The Morgan Car Configurator mobile application is currently in beta. This
								means that some features may not be fully developed and may function
								differently across desktop and mobile platforms. The performance, availability,
								and functionality of features may vary, and the application may contain errors or
								inaccuracies. By using this beta version you accept this statement, please
								consult your Morgan Dealer for the most accurate and up-to-date information.
							</p>
						</div>
				}
			]}
		/>
	);
}